<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card
            color="purple"
            title="تقرير العينات"
            text="من خلال هذا التقرير يمكنك اخراج تقرير مفصل يحتوي على عدد العينات في مدة زمنية معينة و فرز عدد العينات حسب دائرة الصحة، القطاع، المركز الصحي، الجنس و حالة العينة.">


          <v-row dense>
              <v-row class="px-4 pt-4">

                <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
                  <v-autocomplete
                      ref="healthdep"
                      prepend-icon="mdi-account"
                      v-model="healthdep"
                      item-text="text"
                      label="دائرة الصحة"
                      :items="healthdeps"
                  />

                </v-col>

                <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
                  <v-text-field
                      ref="healthsector"
                      prepend-icon="mdi-account"
                      v-model="healthsector"
                      label="القطاع"
                  />

                </v-col>

                <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
                  <v-text-field
                      ref="healthcenter"
                      prepend-icon="mdi-account"
                      v-model="healthcenter"
                      label="المركز الصحي"
                  />

                </v-col>


                <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
                  <v-autocomplete
                      ref="sex"
                      prepend-icon="mdi-account"
                      v-model="sex"
                      label="الجنس"
                      :items="this.$store.state.sexitems"
                  />

                </v-col>

                <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
                  <v-autocomplete
                      ref="cardstatus"
                      prepend-icon="mdi-account"
                      v-model="cardstatus"
                      label="حالة العينة"
                      :items="this.$store.state.cardstatus"
                  />

                </v-col>





                <v-col md="3" sm="12" xs="12" cols="12" class="my-0 py-0">
                <v-dialog ref="dialog" v-model="modal" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="dateRangeText"
                        label="التاريخ"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dates2" scrollable range>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal = false">الغاء</v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="
                    $refs.dialog.save(date);
                    getList();
                  ">موافق</v-btn>
                  </v-date-picker>
                </v-dialog>
                </v-col>




                <v-col md="3" sm="12" xs="12" cols="12">
                  <v-btn @click="submit" dark color="indigo">
                    <v-icon class="mr-1">mdi-chart-box-outline</v-icon> عرض التقرير
                  </v-btn>
                </v-col>
              </v-row>
          </v-row>

          <div v-if="showTable">
            <div><strong>تقرير عدد العينات حسب دوائر الصحة</strong></div>

            <v-row class="mb-4">
            <v-col cols="12">
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                <tr>
                  <th>#</th>
                  <th>دائرة الصحة</th>
                  <th>عدد العينات</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="item in itemsOnHealthDep"
                    :key="item.index"
                >
                  <td>{{ item.num }}</td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.quan }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
            </v-col>
          </v-row>




          <v-row class="mb-4">
            <v-col cols="12">
              <div><strong>تقرير عدد العينات حسب القطاعات</strong></div>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th>#</th>
                    <th>القطاع الصحي</th>
                    <th>عدد العينات</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="item in itemsOnHealthSector"
                      :key="item.index"
                  >
                    <td>{{ item.num }}</td>
                    <td>{{ item.title }}</td>
                    <td>{{ item.quan }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>

          <v-row class="mb-4">
              <v-col cols="12">
                <div><strong>تقرير عدد العينات حسب المراكز الصحية</strong></div>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th>#</th>
                      <th>المراكز الصحية</th>
                      <th>عدد العينات</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="item in itemsOnHealthCenter"
                        :key="item.index"
                    >
                      <td>{{ item.num }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.quan }}</td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
          </v-row>


          <v-row class="mb-4">
              <v-col cols="12">
                <div><strong>تقرير عدد العينات حسب الجنس</strong></div>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th>#</th>
                      <th>الجنس</th>
                      <th>عدد العينات</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="item in itemsOnSex"
                        :key="item.index"
                    >
                      <td>{{ item.num }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.quan }}</td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
          </v-row>


          <v-row class="mb-4">
              <v-col cols="12">
                <div><strong>تقرير عدد العينات حسب حالة العينة</strong></div>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th>#</th>
                      <th>حالة العينة</th>
                      <th>عدد العينات</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="item in itemsOnCardType"
                        :key="item.index"
                    >
                      <td>{{ item.num }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.quan }}</td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
          </v-row>

          </div>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src

import { __HTTP, FormHeader } from "@/utils/utils";

export default {
  name: "ClientReport",

  computed: {
    dateRangeText() {
      //this.getList();
      if (Date.parse(this.dates[0]) > Date.parse(this.dates[1])) {
        return "";
      } else
        return this.dates.join(" ~ ");
    },

    dates2: {
      get() {
        return this.dates;
      },
      set(date) {
        //console.log(date);
        if (Date.parse(date[0]) > Date.parse(date[1]) && date.length > 1) {
          this.dates = [];
        } else {
          this.dates = date;
        }
      }
    },
  },
  methods: {

    getList() {
      this.isloading = true;
      this.items = []
      this.itemsOnHealthSector = [];
      this.itemsOnHealthCenter = [];
      this.itemsOnHealthDep = [];
      this.itemsOnCardType = [];
      this.itemsOnSex = [];
      __HTTP(
          "?do=report&type=cards",
          JSON.stringify({
            daterange: this.dateRangeText,
            healthdep: this.healthdep,
            healthcenter: this.healthcenter,
            healthsector: this.healthsector,
            sex: this.sex,
            cardstatus: this.cardstatus
          }),
          FormHeader,
          res => {
            console.log(res);
            this.isloading = false;
            var i1 = 0;
            var i2 = 0;
            var i3 = 0;
            var i4 = 0;
            var i5 = 0;
            res.map((i) => {
              i.type = parseInt(i.type)

              if (i.type == 1) {
                i1++;
                i.num = i1;
                this.itemsOnHealthDep.push(i)
              } else if (i.type == 2) {
                i2++
                i.num = i2;
                this.itemsOnHealthCenter.push(i)
              } else if (i.type == 3){
                i3++
                i.num = i3;
                this.itemsOnHealthSector.push(i)
              } else if (i.type == 4) {
                i4++
                i.num = i4;
                let index = this.$store.state.cardstatus.findIndex(x => x.value == i.title);
                i.title = this.$store.state.cardstatus[index].text;
                this.itemsOnCardType.push(i);
              } else {
                console.log(i);
                i5++;
                i.num = i5;
                let index = this.$store.state.sexitems.findIndex(x => x.value == i.title);
                i.title = this.$store.state.sexitems[index].text;
                this.itemsOnSex.push(i);
              }
            })
            //this.items = res;
          }
      );
    },
    getHealthDeps() {
      __HTTP("?do=gethealthdeps",{},FormHeader,(res) => {
        res.map((i) => {
          this.healthdeps.push({
            text: i.title,
            value: i.id
          });
        });

        // return x;
      });
    },
    submit() {
        this.getList();
        this.showTable = true
    }
  },

  created() {
    this.getHealthDeps();

  },
  components: {},
  data: () => ({
    search: "",
    clientid: null,
    healthdep: '',
    healthsector: '',
    healthcenter: '',
    cardstatus: '',
    sex: '',
    isloading: false,
    showTable: false,
    modal: false,
    count: 0,
    dates: [],
    healthdeps: [],
    itemsOnCardType: [],
    itemsOnSex: [],
    itemsOnHealthSector: [],
    itemsOnHealthCenter: [],
    itemsOnHealthDep: [],
    loadingtext: "يرجى الإنتظار جار تحميل البيانات ...",
    clients: [],
    items: [],
    user:[],
    snackbar: false,
  })
};
</script>
